import styled from 'styled-components'
// import { blur, unBlur } from './Animations'
import { BlurBoxProps } from '../interfaces'

/* animation: ${(p) => (p.blur ? blur : null)};
  animation: ${(p) => (p.unBlur ? unBlur : null)}; */
export const BlurBox = styled.div<BlurBoxProps>`
  ${({ blur, modalFadeIn }) =>
    blur && !modalFadeIn
      ? `transform:scale(.9); filter:blur(15px);`
      : modalFadeIn
      ? 'transform:scale(1); filter:blur(4px);'
      : `transform:scale(1); filter:blur(0);`}
  transition: all;
  transition-duration: ${({ blur, modalFadeIn }) =>
    blur || modalFadeIn ? '167ms' : '300ms'};
  transition-timing-function: cubic-bezier(0.35, 0, 0.2, 1);
  height: 100%;
`
